import React, { useState, useEffect } from "react";
import Navbar from "../Navbar";
import Sidebar from "./superAdminSidebar";
import Footer from "../Footer";
import { handleAPIRequest } from "../../../api/api";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from 'sweetalert2';
const UserMemberships = () => {
const [memberships, setMemberships] = useState([]);
const [filteredMemberships, setFilteredMemberships] = useState([]);
const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const [searchQuery, setSearchQuery] = useState("");
const [searchQueryMembers, setSearchQueryMembers] = useState(""); // For main page search
const [searchQueryUsers, setSearchQueryUsers] = useState(""); // For modal user search
const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 10;
const token = useSelector((state) => state.auth.token);

const [showEditModal, setShowEditModal] = useState(false);
const [showAddModal, setShowAddModal] = useState(false);
const [selectedMembership, setSelectedMembership] = useState(null);
const [selectedPlan, setSelectedPlan] = useState(null);
const [membershipPlans, setMembershipPlans] = useState([]);
const [visiblePlansIndex, setVisiblePlansIndex] = useState(0);
const [users, setUsers] = useState([]);
const [selectedUser, setSelectedUser] = useState(null);
const fetchMemberships = async () => {
    try {
    const response = await handleAPIRequest("get", "user-memberships", null, null, token);
    setMemberships(response);
    setFilteredMemberships(response); // Initialize filtered list
    } catch (error) {
    console.error("Error fetching user memberships:", error);
    toast.error("Failed to fetch user memberships.");
    }
    };
useEffect(() => {
fetchMemberships();
}, [token]);

const fetchUsers = async () => {
try {
const response = await handleAPIRequest("get", "fetch-members", null, null, token);
setUsers(response);
} catch (error) {
console.error("Error fetching users:", error);
toast.error("Failed to fetch users.");
}
};

const [isAddMembership,setIsAddMembership]=useState(false);
const handleAddMembership = async () => {
    setIsAddMembership(true);
    if (!selectedUser || !selectedPlan) {
        toast.error("Please select both a user and a membership plan.");
        return;
    }

    try {
        // Send the request to add the membership
        await handleAPIRequest("post", "save-memberships", { user_id: selectedUser.id, plan_id: selectedPlan.id }, null, token);

        // Show success toast
        toast.success("Membership added successfully!");

        // Fetch the updated users list or refresh the table data
    
        await fetchMemberships(); // Update this to whatever method you use to get the user list

        // Close the modal after successful addition
        setShowAddModal(false);
    } catch (error) {
        // Handle the error
        toast.error("Failed to add membership.");
        console.error("Error adding membership:", error);
    }finally{
        setIsAddMembership(false);
    }
};
// Handle Status Update

const [isStatusUpdate,setIsStatusUpdate]= useState(false);
const updateMembershipStatus = async (id, newStatus) => {
    setIsStatusUpdate(true);
try {
await handleAPIRequest("patch", `user-memberships/${id}/status`, { status: newStatus }, null, token);
toast.success("Status updated successfully!");

setMemberships((prevMemberships) =>
prevMemberships.map((membership) =>
membership.id === id ? { ...membership, status: newStatus } : membership
)
);

setFilteredMemberships((prevMemberships) =>
prevMemberships.map((membership) =>
membership.id === id ? { ...membership, status: newStatus } : membership
)
);
} catch (error) {
toast.error("Failed to update status.");
console.error("Error updating status:", error);
}finally{
    setIsStatusUpdate(false);
}
};

// Handle Search
useEffect(() => {
const lowerCaseQuery = searchQueryMembers.toLowerCase();
const filtered = memberships.filter((membership) =>
membership.plan.title.toLowerCase().includes(lowerCaseQuery) ||
membership.user.contact_person.toLowerCase().includes(lowerCaseQuery) ||
membership.user.email.toLowerCase().includes(lowerCaseQuery) ||
membership.status.toLowerCase().includes(lowerCaseQuery) ||
membership.start_date.includes(lowerCaseQuery) ||
membership.end_date.includes(lowerCaseQuery)
);

setFilteredMemberships(filtered);
setCurrentPage(1); // Reset to first page after search
}, [searchQueryMembers, memberships]);

// Pagination Logic
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentMemberships = filteredMemberships.slice(indexOfFirstItem, indexOfLastItem);

// Change Page
const paginate = (pageNumber) => setCurrentPage(pageNumber);

// Fetch Plans for Edit Modal
const fetchPlans = async () => {
try {
const response = await handleAPIRequest("get", "plan-names", null, null, token);
if (response) {
setMembershipPlans(response);
} else {
toast.error("Failed to fetch membership plans.");
}
} catch (error) {
console.error("Error fetching membership plans:", error);
}
};

const openEditModal = (membership) => {
setSelectedMembership(membership);
setShowEditModal(true);
fetchPlans();
};

const handlePrev = () => {
if (visiblePlansIndex > 0) {
setVisiblePlansIndex(visiblePlansIndex - 1);
}
};

const handleNext = () => {
if (visiblePlansIndex + 3 < membershipPlans.length) { setVisiblePlansIndex(visiblePlansIndex + 1); } }; const
    handlePlanSelection=async (planId)=> {
    try {
    await handleAPIRequest("patch", `user-memberships/${selectedMembership.id}/plan`, { plan_id: planId }, null, token);
    await fetchMemberships();
    toast.success("Membership plan updated successfully!");
    setShowEditModal(false);
    } catch (error) {
    toast.error("Failed to update membership plan.");
    }
    };

    const deleteMembership = async (id) => {
        // Show confirmation dialog using SweetAlert
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to undo this action!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
        });
    
        // Proceed with deletion if confirmed
        if (result.isConfirmed) {
            try {
                await handleAPIRequest("delete", `user-memberships/${id}`, null, null, token);
                toast.success("Membership deleted successfully!");
    
                // Update memberships list after deletion
                setMemberships((prev) => prev.filter((m) => m.id !== id));
                setFilteredMemberships((prev) => prev.filter((m) => m.id !== id));
            } catch (error) {
                toast.error("Failed to delete membership.");
            }
        } else {
            // Optional: Show a cancellation message (or leave it empty)
            toast.info("Membership deletion canceled.");
        }
    };
    return (
    <div className="flex min-h-screen">
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={()=> setIsSidebarOpen(!isSidebarOpen)} />
            <div className="flex-1 flex flex-col">
                <Navbar toggleSidebar={()=> setIsSidebarOpen(!isSidebarOpen)} />
                    <main className="flex-grow p-6">
                        <h2 className="text-2xl font-bold text-gray-700 mb-4">User Memberships</h2>

                        {/* Search Bar */}
                        <input type="text" placeholder="Search by name, email, status, etc."
                            className="border p-2 rounded w-full mb-4" value={searchQueryMembers} onChange={(e)=>
                        setSearchQueryMembers(e.target.value)}
                        />

                        <button onClick={()=> {
                            setShowAddModal(true);
                            fetchUsers();
                            fetchPlans();
                            }}
                            className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 mb-4"
                            >
                            Add Membership
                        </button>
                        {/* Table */}
                        <div className="overflow-x-auto">
                            <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
                                <thead className="bg-gray-100">
                                    <tr>
                                        <th className="py-3 px-6 text-left text-sm font-medium text-gray-700">Plan Name
                                        </th>
                                        <th className="py-3 px-6 text-left text-sm font-medium text-gray-700">Person
                                            Name</th>
                                        <th className="py-3 px-6 text-left text-sm font-medium text-gray-700">Email</th>
                                        <th className="py-3 px-6 text-left text-sm font-medium text-gray-700">Status
                                        </th>
                                        <th className="py-3 px-6 text-left text-sm font-medium text-gray-700">Start Date
                                        </th>
                                        <th className="py-3 px-6 text-left text-sm font-medium text-gray-700">End Date
                                        </th>
                                        <th className="py-3 px-6 text-left text-sm font-medium text-gray-700">Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentMemberships.length > 0 ? (
                                    currentMemberships.map((membership) => (
                                    <tr key={membership.id} className="border-b">
                                        <td className="py-3 px-6 text-gray-600">{membership.plan.title}</td>
                                        <td className="py-3 px-6 text-gray-600">{membership.user.contact_person}</td>
                                        <td className="py-3 px-6 text-gray-600">{membership.user.email}</td>
                                        <td className="py-3 px-6 text-gray-600">
                                            <select value={membership.status} onChange={(e)=>
                                                updateMembershipStatus(membership.id, e.target.value)}
                                                className="border border-gray-300 rounded p-1"
                                                disabled={isStatusUpdate}
                                                >
                                                <option value="active">Active</option>
                                                <option value="inactive">Inactive</option>
                                            </select>
                                        </td>
                                        <td className="py-3 px-6 text-gray-600">
                                            {new Date(membership.start_date).toLocaleDateString()}
                                        </td>
                                        <td className="py-3 px-6 text-gray-600">
                                            {new Date(membership.end_date).toLocaleDateString()}
                                        </td>
                                        <td>
                                            <button onClick={()=> openEditModal(membership)}
                                                className="text-blue-500 mr-2">
                                                Edit
                                            </button>
                                            <button onClick={()=> deleteMembership(membership.id)}
                                                className="text-red-500">
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                    ))
                                    ) : (
                                    <tr>
                                        <td colSpan="6" className="py-3 px-6 text-center text-gray-500">
                                            No memberships found.
                                        </td>
                                    </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {/* Edit Membership Modal */}
                        {showEditModal && (
                        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
                            <div className="absolute top-[10%] left-1/2 transform -translate-x-1/2 bg-white p-6 rounded-lg shadow-lg w-[600px] max-w-full max-h-[60vh] overflow-y-auto">
                                <h2 className="text-2xl font-bold mb-6 text-center">Edit Membership Plan</h2>

                                <div className="flex justify-between items-center">
                                    {membershipPlans.length > 3 && (
                                    <button onClick={handlePrev}
                                        className="p-2 text-lg text-gray-500 hover:text-gray-700"
                                        disabled={visiblePlansIndex===0}>
                                        &lt;
                                    </button>
                                    )}

                                    <div className="flex gap-4 overflow-hidden">
                                        {membershipPlans.slice(visiblePlansIndex, visiblePlansIndex + 3).map((plan,
                                        index) => (
                                        <div key={index} onClick={()=> handlePlanSelection(plan.id)}
                                            className={`p-6 rounded-lg w-48 cursor-pointer text-center transition-all ${
                                            selectedMembership?.plan.id === plan.id
                                            ? "bg-gray-800 text-white shadow-lg scale-105"
                                            : "bg-gray-200 hover:bg-gray-300"
                                            }`}
                                            >
                                            <h4 className="font-bold text-lg">{plan.title}</h4>
                                            <p className="text-sm font-medium">{plan.price} for {plan.duration}</p>
                                        </div>
                                        ))}
                                    </div>

                                    {membershipPlans.length > 3 && (
                                    <button onClick={handleNext}
                                        className="p-2 text-lg text-gray-500 hover:text-gray-700"
                                        disabled={visiblePlansIndex + 3>= membershipPlans.length}
                                        >
                                        &gt;
                                    </button>
                                    )}
                                </div>

                                <div className="flex justify-end mt-6">
                                    <button onClick={()=> setShowEditModal(false)}
                                        className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                        )}
                        {/* Add Membership Modal */}
                        {showAddModal && (
                        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
                             <div className="absolute top-[10%] left-1/2 transform -translate-x-1/2 bg-white p-6 rounded-lg shadow-lg w-[600px] max-w-full max-h-[60vh] overflow-y-auto">
                                <h2 className="text-2xl font-bold mb-6 text-center">Add New Membership</h2>

                                {/* Search User */}
                                <div className="mb-4">
                                    <input type="text" className="border p-2 rounded w-full"
                                        placeholder="Search by name, email, role..." value={searchQueryUsers}
                                        onChange={(e)=> setSearchQueryUsers(e.target.value)}
                                    />
                                    <div className="mt-2 max-h-60 overflow-y-auto">
                                        {users
                                        .filter((user) => {
                                        const lowerCaseQuery = searchQueryUsers.toLowerCase();
                                        return (
                                        (user.contact_person &&
                                        user.contact_person.toLowerCase().includes(lowerCaseQuery)) ||
                                        (user.email && user.email.toLowerCase().includes(lowerCaseQuery)) ||
                                        (user.role && user.role.toLowerCase().includes(lowerCaseQuery)) ||
                                        (user.role === "supplier_owner" &&
                                        "Supplier".toLowerCase().includes(lowerCaseQuery)) ||
                                        (user.role === "company_owner" && "NGO".toLowerCase().includes(lowerCaseQuery))
                                        ||
                                        (user.role === "company_employee" &&
                                        "NGO".toLowerCase().includes(lowerCaseQuery)) ||
                                        (user.role === "donor_owner" && "Donor".toLowerCase().includes(lowerCaseQuery))
                                        );
                                        })
                                        .map((user) => (
                                        <div key={user.id} onClick={()=> setSelectedUser(user)}
                                            className={`p-2 cursor-pointer hover:bg-gray-200 ${
                                            selectedUser?.id === user.id ? "bg-gray-300" : ""
                                            }`}
                                            >
                                            {user.contact_person} - {user.email} -{" "}
                                            {
                                            // Display the role with the appropriate name
                                            user.role === "supplier_owner"
                                            ? "Supplier"
                                            : user.role === "company_owner" || user.role === "company_employee"
                                            ? "NGO"
                                            : user.role === "donor_owner"
                                            ? "Donor"
                                            : user.role
                                            }
                                        </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Select Plan */}
                                <div className="flex justify-between items-center mb-4">
                                    {membershipPlans.length > 3 && (
                                    <button onClick={handlePrev}
                                        className="p-2 text-lg text-gray-500 hover:text-gray-700"
                                        disabled={visiblePlansIndex===0}>
                                        &lt;
                                    </button>
                                    )}

                                    <div className="flex gap-4 overflow-hidden">
                                        {membershipPlans.slice(visiblePlansIndex, visiblePlansIndex + 3).map((plan,
                                        index) => (
                                        <div key={index} onClick={()=> setSelectedPlan(plan)}
                                            className={`p-6 rounded-lg w-48 cursor-pointer text-center transition-all ${
                                            selectedPlan?.id === plan.id
                                            ? "bg-gray-800 text-white shadow-lg scale-105"
                                            : "bg-gray-200 hover:bg-gray-300"
                                            }`}
                                            >
                                            <h4 className="font-bold text-lg">{plan.title}</h4>
                                            <p className="text-sm font-medium">{plan.price} for {plan.duration}</p>
                                        </div>
                                        ))}
                                    </div>

                                    {membershipPlans.length > 3 && (
                                    <button onClick={handleNext}
                                        className="p-2 text-lg text-gray-500 hover:text-gray-700"
                                        disabled={visiblePlansIndex + 3>= membershipPlans.length}
                                        >
                                        &gt;
                                    </button>
                                    )}
                                </div>

                                {/* Action Buttons */}
                                <div className="flex justify-end mt-6">
                                    <button onClick={()=> setShowAddModal(false)}
                                        className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 mr-4"
                                        >
                                        Cancel
                                    </button>
                                    <button onClick={handleAddMembership}
                                        className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                                          disabled={isAddMembership}
                                   >
              {isAddMembership ? "Saving ..." : "Save"}
                                    </button>
                                </div>
                            </div>
                        </div>
                        )}
                        {/* Pagination */}
                        {filteredMemberships.length > itemsPerPage && (
                        <div className="flex justify-center mt-4">
                            {[...Array(Math.ceil(filteredMemberships.length / itemsPerPage)).keys()].map((num) => (
                            <button key={num + 1} onClick={()=> paginate(num + 1)}
                                className={`px-4 py-2 mx-1 border rounded ${
                                currentPage === num + 1 ? "bg-gray-600 text-white" : "bg-gray-200"
                                }`}
                                >
                                {num + 1}
                            </button>
                            ))}
                        </div>
                        )}
                    </main>
                    <ToastContainer />
                    <Footer />
            </div>
    </div>
    );
    };

    export default UserMemberships;
